import { loader } from '../useStaffCard.utils/loader';
export const staffCardLoader = () => loader('https://yastatic.net/s3/staff-card/_/staff-card.min.js');
